import { z } from 'zod'

export const avatarPatternValues = [
  'FACE_01',
  'FACE_02',
  'FACE_03',
  'FACE_04',
  'FACE_05',
  'FACE_06',
  'FACE_07',
  'FACE_08',
  'FACE_09',
  'FACE_10',
  'FACE_11',
  'FACE_12',
  'FACE_13',
  'FACE_14',
  'FACE_15',
  'FACE_16',
  'FACE_17',
  'FACE_18',
  'FACE_19',
  'FACE_20',
  'FACE_21',
  'FACE_22',
  'FACE_23',
  'FACE_24',
  'FACE_25',
  'FACE_26',
  'FACE_27',
  'FACE_28',
  'FACE_29',
  'FACE_30'
] as const

export const avatarBackgroundValues = [
  'MINT',
  'SKY',
  'INDIGO',
  'VIOLET',
  'ROSE',
  'CORAL',
  'AMBER',
  'LIME',
  'TEAL',
  'SLATE',
  'CYAN',
  'BLUE',
  'PURPLE',
  'FUCHSIA',
  'RED',
  'STONE'
] as const

export const avatarPatternSchema = z.enum(avatarPatternValues)
export const avatarBackgroundSchema = z.enum(avatarBackgroundValues)
export const avatarSchema = z.object({
  pattern: avatarPatternSchema,
  background: avatarBackgroundSchema
})

export const accountDisplaySchema = z.object({
  id: z.number().int().positive(),
  name: z.string(),
  isSystem: z.boolean().optional(),
  avatar: avatarSchema.nullable()
})

const nullablePhoneSchema = z
  .string()
  .trim()
  .max(30, '手机号不能超过 30 个字符')
  .nullable()
  .transform((value) => value || null)

export const profileSchema = z.object({
  accountId: z.number().int().positive(),
  memberId: z.number().int().positive(),
  email: z.email(),
  name: z.string(),
  phone: z.string().nullable(),
  avatar: avatarSchema.nullable()
})

export const profileUpdateSchema = z
  .object({
    name: z.string().trim().min(2, '名称长度不能小于 2').max(80, '名称不能超过 80 个字符'),
    phone: nullablePhoneSchema,
    avatar: avatarSchema.nullable().default(null)
  })
  .strict()

export type AvatarPattern = z.infer<typeof avatarPatternSchema>
export type AvatarBackground = z.infer<typeof avatarBackgroundSchema>
export type AvatarConfig = z.infer<typeof avatarSchema>
export type AccountDisplay = z.infer<typeof accountDisplaySchema>
export type Profile = z.infer<typeof profileSchema>
export type ProfileUpdateInput = z.infer<typeof profileUpdateSchema>
